import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import ReactEcharts from 'echarts-for-react';
import {
  PredictionChartSC,
  ChartWrapSC,
  PredictionChartWrapperSC,
  PredictionChartLeftColSC,
} from './prediction-chart.styled';
import { HeadingThree } from '../../typography';
import moment from 'moment';
import 'moment/min/locales';
import { FormattedHTMLMessage } from 'react-intl';
import { usePredictionChartOptions } from './prediction-chart.utils';
import PredictionCalculator from '../../prediction-calculator';
import InlineLoading from '../../ui/inline-loading';

const PredictionChart = ({ appLanguage, chartData, chartDataLoading }) => {
  useEffect(() => {
    moment.locale(appLanguage);
  }, [appLanguage]);

  const formattedChartData = React.useMemo(
    () =>
      chartData.map((item) => {
        const timestamp = Object.keys(item)[0];
        return {
          date: new Date(Number(timestamp)),
          investments: item[timestamp].basic[0],
          progress: item[timestamp].basic[1],
          investmentsPrediction: item[timestamp]?.with_deposits?.[0] ?? 0,
          progressPrediction: item[timestamp]?.with_deposits?.[1] ?? 0,
        };
      }),
    [chartData]
  );

  const chartOptions = usePredictionChartOptions(formattedChartData);

  return (
    <PredictionChartWrapperSC>
      <div className="top-text-wrap">
        <HeadingThree className="bold">
          <FormattedHTMLMessage
            id="investor_prediction_title"
            defaultMessage="investor_prediction_title"
          />
        </HeadingThree>
      </div>
      <div className="content-wrap">
        <PredictionChartLeftColSC>
          <PredictionCalculator />
        </PredictionChartLeftColSC>

        <PredictionChartSC>
          <ChartWrapSC>
            {chartDataLoading ? (
              <div className="loading-wrapper">
                <InlineLoading />
              </div>
            ) : null}
            <ReactEcharts option={chartOptions} style={{ height: '100%' }} />
          </ChartWrapSC>
        </PredictionChartSC>
      </div>
    </PredictionChartWrapperSC>
  );
};

const mapStateToProps = (state) => {
  return {
    appLanguage: state.app.language,
    chartData: state.estimates.chartData,
    chartDataLoading: state.estimates.chartDataLoading,
  };
};

export default connect(mapStateToProps)(PredictionChart);
